export default __webpack_public_path__ + "static/media/User_Prians.7c34bdbd.png";